<template>
    <Paper>
        <div class="dataDictionary" v-if='listFlag'>
            <div class="dataDictionaryHead">
                <el-row>
                    <el-col :span="21">
                        <el-row>
                            <el-col class="dataDictionaryHead-item">
                                <el-input v-model="searchData['code']" @keyup.enter.native="searchChange" :placeholder="$translate('lang.E3202103180002', { defaultText: '字典编码' })"></el-input>
                            </el-col>
                            <el-col class="dataDictionaryHead-item">
                                <el-input v-model="searchData['name']" @keyup.enter.native="searchChange" :placeholder="$translate('lang.E3202103180003', { defaultText: '字典名称' })"></el-input>
                            </el-col>
                            <div>
                                <el-button type="primary" :loading="Searchloading" size="mini" @click="searchChange" icon='el-icon-search'>
                                    {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                                </el-button>
                                <el-button @click="restSearchChange" size="mini" class="sn-search-reset-button">
                                    {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                                </el-button>
                            </div>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div class='listTable'>
                <m-table
                  ref="listTable"
                  @btn-event='btnEvent'
                  :pageTotal="pageTotal"
                  :tableData="listData"
                  :currentPage='currentPage'
                  @pageChange="pageChange"
                  @sizeChange="sizeChange"
                  :config="tableConfig">
                  <div slot="page-module-btn">
                      <el-button @click="add" icon="el-icon-plus" type="primary" size="mini">
                        {{$translate('lang.E3202102260005', { defaultText: '新增' })}}
                    </el-button>
                  </div>
                </m-table>
            </div>
            <el-dialog
                :title="listDialogText"
                :visible.sync="listDialogVisible"
                width="400px"
                :before-close="cancelCheck"
            >
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width='70px' class="ruleForm">
                <el-form-item :label="$translate('lang.E3202103180002', { defaultText: '字典编码' })" prop="code" :title="$translate('lang.E3202103180002', { defaultText: '字典编码' })">
                  <el-input v-model="ruleForm.code" :disabled='ruleFormCodeFlag'></el-input>
                </el-form-item>
                <el-form-item :label="$translate('lang.E3202103180003', { defaultText: '字典名称' })" prop="name" :title="$translate('lang.E3202103180003', { defaultText: '字典名称' })">
                    <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="cancelCheck" size="mini">
                    {{$translate('lang.E3202101270002', { defaultText: '取 消' })}}
                </el-button>
                <el-button type="primary" @click="submit" size="mini">
                    {{$translate('lang.E3202103010008', { defaultText: '保 存' })}}
                </el-button>
              </span>
            </el-dialog>
        </div>
        <div class="detail" v-else>
            <div class="detailHead">
                <div><el-button @click="back" size="mini" icon='el-icon-arrow-left'>
                    {{$translate('lang.E3202101260028', { defaultText: '返回' })}}
                </el-button></div>
                <ul>
                    <li>
                        <span class="label">
                            {{$translate('lang.E3202103180002', { defaultText: '字典编码' })}}：
                        </span>
                        <span class="data">{{dictionaryText.code}}</span>
                    </li>
                    <li>
                        <span class="label">
                            {{$translate('lang.E3202103180003', { defaultText: '字典名称' })}}：
                        </span>
                        <span class="data">{{dictionaryText.name}}</span>
                    </li>
                </ul>
            </div>
            <div class='detailTable'>
                <m-table
                  ref="detailTable"
                  @btn-event='btnEventByDetail'
                  :pageTotal="pageTotalByDetail"
                  :tableData="listDataByDetail"
                  :currentPage='currentPageByDetail'
                  @pageChange="pageChangeByDetail"
                  @sizeChange="sizeChangeByDetail"
                  :config="detailConfig">
                  <div  slot="page-module-btn">
                    <el-button @click="addByDetail" icon="el-icon-plus" type="primary" size="mini">
                        {{$translate('lang.E3202102260005', { defaultText: '新增' })}}
                    </el-button>
                  </div>
                </m-table>
            </div>
            <el-dialog
                :title="detailDialogText"
                :visible.sync="detailDialogVisible"
                width="50%"
                :before-close="cancelCheckByDetail"
            >
            <el-form :model="detailForm" :rules="detailrules" ref="detailForm" label-width='80px' class="ruleForm">
                  <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$translate('lang.E3202103190003', { defaultText: '编码' })" prop="code">
                            <el-input v-model="detailForm.code"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                       <el-form-item :label="$translate('lang.E3202103190004', { defaultText: '名称' })" prop="name">
                            <el-input v-model="detailForm.name"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                       <el-form-item :label="$translate('lang.E3202101250010', { defaultText: '状态' })">
                            <el-switch
                            v-model="detailForm.enableFlag"
                            :active-value=1
                            :inactive-value=0
                            active-color="#33c9cc"
                            inactive-color="#dcdfe6"
                            :active-text="$translate('lang.E3202102260004', { defaultText: '启用' })"
                            :inactive-text="$translate('lang.E3202102260003', { defaultText: '停用' })">
                            </el-switch>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                       <el-form-item label="扩展字段1" prop="def1">
                         <el-input v-model="detailForm.def1"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                       <el-form-item label="扩展字段2" prop="def2">
                         <el-input v-model="detailForm.def2"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                       <el-form-item label="扩展字段3" prop="def3">
                         <el-input v-model="detailForm.def3"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                       <el-form-item label="扩展字段4" prop="def4">
                         <el-input v-model="detailForm.def4"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                       <el-form-item label="扩展字段5" prop="def5">
                         <el-input v-model="detailForm.def5"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item :label="$translate('lang.E3202101260050', { defaultText: '备注' })" prop="remake">
                            <el-input v-model="detailForm.remake"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="cancelCheckByDetail" size="mini">
                    {{$translate('lang.E3202101270002', { defaultText: '取 消' })}}
                </el-button>
                <el-button type="primary" @click="submitByDetail" size="mini">
                    {{$translate('lang.E3202103010008', { defaultText: '保 存' })}}
                </el-button>
              </span>
            </el-dialog>
        </div>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import mTable from '../../../components/IdentityComponent/Main';
import tableConfig from './tableConfig.js';
import detailConfig from './detailConfig.js';
import { getDictionaryList, addAndChageDictionary, getDictionaryDetail, addAndChageDicDetail, searchByDictCodes,
    deleteDictCodes, deleteDetailDictCodes } from '../../../api/systemManagementApi.js';
export default {
    name: 'dataDictionary',
    components: { Paper, mTable },
    data() {
        return {
            tableConfig,
            detailConfig,
            listFlag: true,
            listDialogText: this.$translate('lang.E3202102260005', { defaultText: '新增' }),
            detailDialogText: this.$translate('lang.E3202102260005', { defaultText: '新增' }),
            ruleFormCodeFlag: false,
            Searchloading: false,
            searchData: {
                code: '',
                name: ''
            },
            listData: [],
            pageTotal: 0,
            currentPage: 1,
            listDataByDetail: [],
            pageTotalByDetail: 0,
            currentPageByDetail: 1,
            listDialogVisible: false,
            detailDialogVisible: false,
            esId: '',
            dictDet: {
                dictCode: ''
            },
            dictionaryText: {
                code: '',
                name: ''
            },
            ruleForm: {},
            detailForm: {},
            rules: {
                code: [
                    { required: true, message: this.$translate('lang.E3202103190001', { defaultText: '请输入字典编码' }), trigger: 'blur' }
                ],
                name: [
                    { required: true, message: this.$translate('lang.E3202103190002', { defaultText: '请输入字典名称' }), trigger: 'blur' }
                ]
            },
            detailrules: {
                code: [
                    { required: true, message: this.$translate('lang.E3202103190001', { defaultText: '请输入字典编码' }), trigger: 'blur' }
                ],
                name: [
                    { required: true, message: this.$translate('lang.E3202103190002', { defaultText: '请输入字典名称' }), trigger: 'blur' }
                ]
            },
            dictObj: {}
        };
    },
    methods: {
        handleDicts() {
            const params = {
                dictCodes: 'SN_STATUS'
            };
            searchByDictCodes(params).then(res => {
                if (res.code === '0') {
                    this.dictObj = res.data;
                }
            });
        },
        initSearcheData() {
            this.searchData = {
                code: '',
                name: ''
            };
        },
        initruleForm() {
            this.ruleForm = {
                code: '',
                name: ''
            };
            this.esId = '';
        },
        initdetailForm() {
            this.detailForm = {
                code: '',
                name: '',
                enableFlag: 1,
                remake: '',
                def1: '',
                def2: '',
                def3: '',
                def4: '',
                def5: ''
            };
        },
        restSearchChange() {
            this.initSearcheData();
        },
        handleSearchData() {
            const params = {
                ...this.searchData,
                pageNo: this.tableConfig.page.pageNo,
                pageSize: this.tableConfig.page.pageSize
            };
            Object.keys(params).forEach(item => {
                if (!params[item]) {
                    delete params[item];
                }
            });
            return params;
        },
        searchChange() {
            this.tableConfig.page.pageNo = 1;
            this.currentPage = 1;
            const params = this.handleSearchData();
            this.getData(params);
        },
        getData(params) {
            getDictionaryList(params).then(res => {
                if (res.code === '0') {
                    this.listData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        add() {
            this.listDialogText = this.$translate('lang.E3202102260005', { defaultText: '新增' });
            this.listDialogVisible = true;
            this.ruleFormCodeFlag = false;
            this.$nextTick(() => {
                this.$refs['ruleForm'].resetFields();
                this.initruleForm();
            });
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.currentPage = pageNo;
            const params = this.handleSearchData();
            this.getData(params);
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageSize = pageSize;
            const params = this.handleSearchData();
            this.getData(params);
        },
        // 取消非空验证
        cancelCheck() {
            this.$refs['ruleForm'].resetFields();
            this.listDialogVisible = false;
        },
        submit() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    if (this.listDialogText === this.$translate('lang.E3202102260005', { defaultText: '新增' })) {
                        const params = this.ruleForm;
                        addAndChageDictionary(params).then(res => {
                            if (res.code === '0') {
                                this.listDialogVisible = false;
                                this.$message.success(this.$translate('lang.EXC202103010014', { defaultText: '新增成功' }));
                                const params = {
                                    pageNo: 1,
                                    pageSize: 10
                                };
                                this.currentPage = 1;
                                this.getData(params);
                            }
                        });
                    } else {
                        const params1 = this.ruleForm;
                        addAndChageDictionary(params1).then(res => {
                            if (res.code === '0') {
                                this.listDialogVisible = false;
                                this.$message.success(this.$translate('lang.EXC202102260002', { defaultText: '修改成功' }));
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        btnEvent(data, event) {
            switch (event) {
            case 'look':
                this.listFlag = false;
                this.dictDet.dictCode = data.code;
                this.dictionaryText.code = data.code;
                this.dictionaryText.name = data.name;
                this.getDetailList();
                break;
            case 'edit':
                this.listDialogVisible = true;
                this.listDialogText = this.$translate('lang.E3202103190005', { defaultText: '修改' });
                this.ruleFormCodeFlag = true;
                this.$nextTick(() => {
                    this.$refs['ruleForm'].resetFields();
                    this.initruleForm();
                    this.ruleForm = JSON.parse(JSON.stringify(data));
                });
                break;
            case 'delete':
                this.deleteDict(data);
                break;
            default:
                break;
            }
        },
        getDetailList() {
            const params = { ...this.dictDet };
            params.pageNo = this.detailConfig.page.pageNo;
            params.pageSize = this.detailConfig.page.pageSize;
            getDictionaryDetail(params).then(res => {
                if (res.code === '0') {
                    this.listDataByDetail = res.data.list;
                    this.listDataByDetail.forEach(item => {
                        this.dictObj['SN_STATUS'].map(item2 => {
                            if (String(item.enableFlag) === item2.code) {
                                item.enableFlagDict = item2.name;
                            }
                        });
                    });
                    this.pageTotalByDetail = res.data.totalCount;
                }
            });
        },
        deleteDict(data) {
            if (!data || !data.esId) {
                return;
            }
            this.$confirm(this.$translate('lang.E3202112170001', { defaultText: '是否删除该条数据？' }),
                this.$translate('lang.E3202102220028', { defaultText: '提示' }), {
                    confirmButtonText: this.$translate('lang.E3202101270001', { defaultText: '确定' }),
                    cancelButtonText: this.$translate('lang.E3202101270002', { defaultText: '取消' })
                }).then(() => {
                const params = {
                    esId: data.esId
                };
                deleteDictCodes(params).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(this.$translate('lang.EXC202102230001', { defaultText: '删除成功' }));
                        const searchParams = this.handleSearchData();
                        this.getData(searchParams);
                    }
                });
            });
        },
        addByDetail() {
            this.detailDialogText = this.$translate('lang.E3202102260005', { defaultText: '新增' });
            this.detailDialogVisible = true;
            this.$nextTick(() => {
                this.$refs['detailForm'].resetFields();
                this.initdetailForm();
            });
        },
        pageChangeByDetail(pageNo) {
            this.detailConfig.page.pageNo = pageNo;
            this.currentPage = pageNo;
            this.getDetailList();
        },
        sizeChangeByDetail(pageSize) {
            this.detailConfig.page.pageSize = pageSize;
            this.getDetailList();
        },
        cancelCheckByDetail() {
            this.$refs['detailForm'].resetFields();
            this.detailDialogVisible = false;
        },
        btnEventByDetail(data, event) {
            switch (event) {
            case 'edit':
                this.detailDialogVisible = true;
                this.detailDialogText = this.$translate('lang.E3202103190005', { defaultText: '修改' });
                this.$nextTick(() => {
                    this.initdetailForm();
                    this.detailForm = JSON.parse(JSON.stringify(data));
                });
                break;
            case 'delete':
                this.deleteDetailDict(data);
                break;
            default:
                break;
            }
        },
        submitByDetail() {
            this.$refs['detailForm'].validate((valid) => {
                if (valid) {
                    const params = { ...this.detailForm };
                    params.dictCode = this.dictDet.dictCode;
                    if (this.detailDialogText === this.$translate('lang.E3202102260005', { defaultText: '新增' })) {
                        addAndChageDicDetail(params).then(res => {
                            if (res.code === '0') {
                                this.$message.success(this.$translate('lang.EXC202103010014', { defaultText: '新增成功' }));
                                this.getDetailList();
                                this.detailDialogVisible = false;
                            }
                        });
                    } else {
                        addAndChageDicDetail(params).then(res => {
                            if (res.code === '0') {
                                this.$message.success(this.$translate('lang.EXC202102260002', { defaultText: '修改成功' }));
                                this.getDetailList();
                                this.detailDialogVisible = false;
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        deleteDetailDict(data) {
            if (!data || !data.esId) {
                return;
            }
            this.$confirm(this.$translate('lang.E3202112170001', { defaultText: '是否删除该条数据？' }),
                this.$translate('lang.E3202102220028', { defaultText: '提示' }), {
                    confirmButtonText: this.$translate('lang.E3202101270001', { defaultText: '确定' }),
                    cancelButtonText: this.$translate('lang.E3202101270002', { defaultText: '取消' })
                }).then(() => {
                const params = {
                    esId: data.esId
                };
                deleteDetailDictCodes(params).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(this.$translate('lang.EXC202102230001', { defaultText: '删除成功' }));
                        this.getDetailList();
                    }
                });
            });
        },
        back() {
            this.listFlag = true;
        }
    },
    mounted () {
        this.initruleForm();
        this.initdetailForm();
        this.handleDicts();
        this.searchChange();
    }
};
</script>
<style lang="less">
.dataDictionary {
    .dataDictionaryHead {
        margin-bottom: 20px;
    }
    .dataDictionaryHead-item{
        width: 190px;
        margin-right: 10px;
    }
    .listTable {
        .nPanel .row-bg {
            margin-top: 20px;
        }
        .nPanel .el-table {
            height: calc(100vh - 180px) !important;
        }
    }
    .el-dialog__body {
        border-bottom: 1px solid #E8E8E8;
        padding-bottom: 0px;
    }
    .el-dialog__footer {
        padding: 15px;
        padding-top: 15px;
    }
    .el-form-item__label {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
.detail {
    .detailHead {
        display: flex;
        padding-bottom: 20px;
        // border-bottom: 1px solid #e8e8e8;
        ul {
            width: 100%;
            display: flex;
            background-color: #f8f8f8;
            margin-left: 20px;
            box-sizing: border-box;
            height: 50px;
            line-height: 50px;
            align-items: center;
            li {
                font-size: 12px;
                padding-left: 100px;
                .label {
                    color:#7b7e7e;
                    font-size: 12px;
                    margin-right: 5px;
                }
            }
        }
    }
    .detailTable {
        .nPanel .row-bg {
            margin-top: 20px;
        }
        .nPanel .el-table {
            height: calc(100vh - 202px) !important;
        }
    }
}
</style>